import { styleguideVars as colors } from "lib/styleguideVars";
import React from "react";
import styles from "./Colors.scss";
export const Colors = () => (
  <div className={styles.Colors}>
    <h1>Colors</h1>
    <h2>Primary</h2>
    <div className={styles.swatchContainer}>
      <Swatch color="orange" />
      <Swatch color="lightorange" />
    </div>
    <h2>Secondary</h2>
    <div className={styles.swatchContainer}>
      <Swatch color="teal" />
      <Swatch color="darkteal" />
      <Swatch color="pistachio" />
      <Swatch color="darkpistachio" />
      <Swatch color="sand" />
      <Swatch color="darksand" />
      <Swatch color="facebookblue" />
      <Swatch color="vividblue" />
    </div>

    <h2>Greys</h2>
    <div className={styles.swatchContainer}>
      <Swatch color="grey50" />
      <Swatch color="grey100" />
      <Swatch color="grey200" />
      <Swatch color="grey300" />
      <Swatch color="grey400" />
      <Swatch color="grey500" />
      <Swatch color="grey600" />
      <Swatch color="grey700" />
      <Swatch color="grey800" />
      <Swatch color="grey900" />
    </div>
    <h2>Highlight and Icons</h2>
    <div className={styles.swatchContainer}>
      <Swatch color="purple" />
      <Swatch color="darkpurple" />
      <Swatch color="red" />
      <Swatch color="darkred" />
      <Swatch color="lightred" />
      <Swatch color="brown" />
      <Swatch color="green" />
      <Swatch color="turquoise" />
    </div>
    <h2>UI constants</h2>
    <div className={styles.swatchContainer}>
      <Swatch color="modalbackground" />
    </div>
  </div>
);

const Swatch = ({ color }) => (
  <div className={styles.Swatch}>
    <div className={styles.colorSquare} style={{ background: colors[color] }} />
    <p>${color}</p>
    <p>
      <code>{colors[color]}</code>
    </p>
  </div>
);
